import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async updatePatient(pharmacyId, patientId, payload) {
    const response = await axiosPrivate.put(
      `/pharmacies/${pharmacyId}/patient/${patientId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPharmacyPatient({ pharmacyId, patientId, dependents }) {
    const queryString = dependents ? `?${qs.stringify({ dependents })}` : '';
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patients/${patientId}${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async updatePharmacyPatient({ pharmacyId, patientId, dependentId, payload }) {
    const patientUpdateUrl = dependentId
      ? `/pharmacies/${pharmacyId}/patients/${patientId}/dependents/${dependentId}`
      : `/pharmacies/${pharmacyId}/patients/${patientId}`;

    const response = await axiosPrivate.put(patientUpdateUrl, payload);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async checkPatient({ pharmacyId, email, patientType }) {
    const query = new URLSearchParams({ email }).toString();
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patient-check/${patientType}?${query}`
    );

    return response.data;
  },

  async getPatientOrderSchedules({ pharmacyId, patientId, dependents }) {
    const queryString = dependents ? `?${qs.stringify({ includeDependents: true })}` : '';
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patients/${patientId}/order-schedules${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async createPatient(pharmacyId, payload) {
    const response = await axiosPrivate.post(`/pharmacies/${pharmacyId}/patient`, payload);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async searchDMRPatient(pharmacyId, name) {
    const queryString = qs.stringify({ name });
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/dmr-patient-search?${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getInactiveDMRPatients(pharmacyId) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/dmr-patients/inactive`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPharmacyPatientMessages({ pharmacyId, patientId, limit }) {
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patients/${patientId}/messages?limit=${limit}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data;
  },

  async postMessage({ pharmacyId, patientId, message, date }) {
    const response = await axiosPrivate.post(
      `/pharmacies/${pharmacyId}/patients/${patientId}/messages`,
      { message_body: message, message_date: date }
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.data[0];
  },
};
